import { I as Icon, _ as _extends } from './Icon-465858dc.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const Play = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M12 22.0001c5.5229 0 10.0001-4.4772 10.0001-10.0001 0-5.5228-4.4772-10-10.0001-10C6.4772 2 2 6.4772 2 12c0 5.5229 4.4772 10.0001 10 10.0001zM10.53 7.9563C9.864 7.54 9 8.0188 9 8.8043v6.3915c0 .7854.864 1.2642 1.53.848l5.1132-3.1958c.6267-.3917.6267-1.3043 0-1.696L10.53 7.9563z",
      clipRule: "evenodd"
    }),
    stroke: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M9 8.8042c0-.7854.864-1.2642 1.53-.848l5.1132 3.1958c.6267.3917.6267 1.3043 0 1.696L10.53 16.0438c-.666.4162-1.53-.0626-1.53-.848V8.8042zM13.2264 12L11 13.3915v-2.783L13.2264 12z",
      clipRule: "evenodd"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M22.0001 12c0 5.5229-4.4772 10.0001-10.0001 10.0001-5.5228 0-10-4.4772-10-10.0001C2 6.4772 6.4772 2 12 2c5.5229 0 10.0001 4.4772 10.0001 10zm-2 0c0 4.4183-3.5818 8.0001-8.0001 8.0001S4 16.4183 4 12s3.5817-8 8-8 8.0001 3.5817 8.0001 8z",
      clipRule: "evenodd"
    }))
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
Play.displayName = "PlayIcon";

export { Play, Play as default };
